(() => {
  const normalize = (value) => String(value ?? '').normalize('NFKC').trim();
  const timers = new WeakMap();

  function readVariants(picker) {
    const script = picker?.querySelector('script[data-product-variants]');
    if (!script) return [];
    try {
      const parsed = JSON.parse(script.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Błąd mapy wariantów.', error);
      return [];
    }
  }

  function selectedNames(picker) {
    return Array.from(picker.querySelectorAll('.variant-option')).map((group) => {
      const select = group.querySelector('select');
      const control = select ? select.selectedOptions[0] : group.querySelector('input[type="radio"]:checked, input:checked');
      return control ? normalize(control.dataset.optionValueName ?? control.value) : null;
    }).filter((value) => value !== null);
  }

  function resolveVariant(picker) {
    const names = selectedNames(picker);
    if (!names.length) return null;
    const variants = readVariants(picker);
    const exact = variants.find((variant) =>
      Array.isArray(variant.options) &&
      variant.options.length === names.length &&
      variant.options.every((option, index) => normalize(option) === names[index])
    );
    if (exact) return exact;
    const folded = names.map((name) => name.toLocaleLowerCase('pl'));
    return variants.find((variant) =>
      Array.isArray(variant.options) &&
      variant.options.length === folded.length &&
      variant.options.every((option, index) => normalize(option).toLocaleLowerCase('pl') === folded[index])
    ) || null;
  }

  function updateProductInfo(productInfo) {
    if (!productInfo?.isConnected) return;
    const picker = productInfo.querySelector('variant-picker');
    if (!picker) return;
    const variant = resolveVariant(picker);
    if (!variant?.id) return;

    const canAdd = variant.can_add !== undefined ? variant.can_add !== false : variant.available !== false;
    productInfo.querySelectorAll('product-form').forEach((productForm) => {
      const form = productForm.querySelector('form[data-type="add-to-cart-form"]') || productForm.querySelector('form');
      const input = form?.querySelector('input[name="id"].product-variant-id, input[name="id"]');
      if (input) {
        input.value = String(variant.id);
        input.disabled = false;
      }

      const button = productForm.querySelector('button[type="submit"][name="add"]');
      if (!button) return;
      button.disabled = !canAdd;
      if (canAdd) button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', 'true');
      button.classList.toggle('is-disabled', !canAdd);
      const label = button.querySelector('[data-button-text]');
      if (label) {
        const nextLabel = canAdd
          ? (window.variantStrings?.addToCart || 'Dodaj do koszyka')
          : (window.variantStrings?.soldOut || 'Wyprzedane');
        if (label.textContent !== nextLabel) label.textContent = nextLabel;
      }
    });
  }

  function schedule(productInfo) {
    if (!productInfo) return;
    clearTimeout(timers.get(productInfo));
    updateProductInfo(productInfo);
    const timer = setTimeout(() => updateProductInfo(productInfo), 350);
    timers.set(productInfo, timer);
    setTimeout(() => updateProductInfo(productInfo), 1100);
  }

  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.('variant-picker');
    if (!picker) return;
    schedule(picker.closest('product-info'));
  });
  document.addEventListener('variant-picker:changed', (event) => {
    schedule(event.target.closest('product-info'));
  });
  document.addEventListener('product-info:loaded', (event) => schedule(event.target));
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('product-info').forEach(schedule);
  });

  const observer = new MutationObserver((mutations) => {
    const infos = new Set();
    mutations.forEach((mutation) => {
      const targetInfo = mutation.target.nodeType === 1 ? mutation.target.closest?.('product-info') : null;
      if (targetInfo) infos.add(targetInfo);
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('product-info')) infos.add(node);
        node.querySelectorAll?.('product-info').forEach((info) => infos.add(info));
      });
    });
    infos.forEach(schedule);
  });

  const start = () => {
    document.querySelectorAll('product-info').forEach(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
